import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Seo from './Seo';
import ProductSidebar from './ProductSidebar';
import { useUser, studioThemeClass } from '../contexts/UserContext';
import CoverLetterStudio from './CoverLetterStudio';
import './ResumeBuilderLanding.css';

const CoverLetterStudioPage = () => {
  const navigate = useNavigate();
  // Theme lives in UserContext so every studio shares one switch — see
  // STUDIO_THEMES there. It used to be local state with its own storage key.
  const { user, studioTheme } = useUser();

  // Auth modal lives on the homepage; route there with a flag when needed.
  const setShowAuthModal = useCallback((show) => {
    if (show) navigate('/?openLogin=1');
  }, [navigate]);

  return (
    // `rbl-page` supplies the shared design tokens; the theme class flips this
    // one route's surface (see the light-theme block in CoverLetterStudio.css).
    // Don't restyle `rbl-page` itself — /resume-studio and the resume landing
    // page use it too.
    <div className={`rbl-page cls-page ${studioThemeClass(studioTheme)}`}>
      <Seo
        title="Cover Letter Studio — AI-Powered Cover Letter Generator"
        description="Fill in the job details on the left, watch your AI-tailored cover letter render live on the right, and export a polished DOCX or PDF in seconds."
        path="/cover-letter-session"
      />
      <Header setShowAuthModal={setShowAuthModal} />
      <ProductSidebar user={user} setShowAuthModal={setShowAuthModal} />

      <CoverLetterStudio setShowAuthModal={setShowAuthModal} />
    </div>
  );
};

export default CoverLetterStudioPage;
